import { render, staticRenderFns } from "./CtintCustomerCreateUpdate.vue?vue&type=template&id=12c9eafc&"
import script from "./CtintCustomerCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CtintCustomerCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports